import { React, useEffect, useState } from "react";
import img_pajaro_avifauna from "../../../assets/images/img_pajaro_avifauna.png";
import ico_pajaro from "../../../assets/icons/ico_pajaro.svg";
import GroupInfoSection from "../../../components/groupInfoSection";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const BirdLifeScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "https://drive.google.com/uc?export=download&id=1tIJ6tOcvie2j2X2iOU0YxDypFkzvSFX0";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full">
         {width > 1300 ? (
         <div>
<div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
          <div className="relative w-full lg:h-full">
          <VideoGroupsBanner videoSource={bosque} left="32%" />
          <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <img
          
            src={img_pajaro_avifauna}
            alt=""
            className="w-full  pr-[19.8rem] z-40  bottom-0 absolute"
          />
        </div>

        <GroupInfoSection
          webvrurl="https://niv6.vercel.app/"
          icon={ico_pajaro}
          title={<p>Avifauna</p>}
          subTitle=""
          textFirstTab={
            <p>
              Las aves realizan muchos trabajos en un ecosistema. Algunas son
              depredadoras de animales, polinizadoras, consumidoras de frutos y
              dispersoras de semillas. Las aves trabajan en todos los niveles de
              la naturaleza y se consideran un grupo termómetro porque indican
              cuál es el nivel de salud y complejidad del ambiente en el cual
              habitan.
            </p>
          }
          textSecondTab={
            <p>
              Por ser un grupo de animales bien conocido, de fácil avistamiento
              y diverso, las aves son muy valiosas en los monitoreos de
              ecosistemas, ya que permiten evaluar los cambios experimentados
              por estos. Una de las ventajas de trabajar con el grupo es la
              posibilidad de monitorear con varios métodos cuya escogencia
              depende de los objetivos que se plantean, los recursos disponibles
              y las características del ecosistema.
            </p>
          }
          textThirdTab={
            <p>
              Monitorear la presencia de aves residentes y migratorias en los
              fragmentos de bosque secundario y bosques de galería asociados a
              paisajes productivos mediante avistamientos y reconocimiento de
              cantos. Se recomienda el monitoreo cada 6 meses en cada punto de
              muestreo. Se propone uno durante las épocas de migración y las
              épocas seca y lluviosa, según la región geográfica. En cuanto a
              las horas de día, la mayoría de las aves en los bosques son más
              activas al amanecer.
            </p>
          }
        ></GroupInfoSection>
      </div>
         </div>
         ):(
            <div className="min-h-[100vh] grid grid-cols-1 h-full overflow-hidden">
            <div className=" bg-[#002E0F] overflow-hidden left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
              <GoToPage
                page="/grupos"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div style={{"z-index":"1"}}>
            <GroupInfoSection
          webvrurl="https://niv6.vercel.app/"
          icon={ico_pajaro}
          title={<p>Avifauna</p>}
          subTitle=""
          textFirstTab={
            <p>
              Las aves realizan muchos trabajos en un ecosistema. Algunas son
              depredadoras de animales, polinizadoras, consumidoras de frutos y
              dispersoras de semillas. Las aves trabajan en todos los niveles de
              la naturaleza y se consideran un grupo termómetro porque indican
              cuál es el nivel de salud y complejidad del ambiente en el cual
              habitan.
            </p>
          }
          textSecondTab={
            <p>
              Por ser un grupo de animales bien conocido, de fácil avistamiento
              y diverso, las aves son muy valiosas en los monitoreos de
              ecosistemas, ya que permiten evaluar los cambios experimentados
              por estos. Una de las ventajas de trabajar con el grupo es la
              posibilidad de monitorear con varios métodos cuya escogencia
              depende de los objetivos que se plantean, los recursos disponibles
              y las características del ecosistema.
            </p>
          }
          textThirdTab={
            <p>
              Monitorear la presencia de aves residentes y migratorias en los
              fragmentos de bosque secundario y bosques de galería asociados a
              paisajes productivos mediante avistamientos y reconocimiento de
              cantos. Se recomienda el monitoreo cada 6 meses en cada punto de
              muestreo. Se propone uno durante las épocas de migración y las
              épocas seca y lluviosa, según la región geográfica. En cuanto a
              las horas de día, la mayoría de las aves en los bosques son más
              activas al amanecer.
            </p>
          }
        ></GroupInfoSection>
            </div>
            <div className="relative  w-full lg:h-full flex justify-center lg:mt-20 md:mt-20 sm:mt-20 mt-20">
              <GroupsVideoFooter videoSource={bosque} />
             
              <img
              
                src={img_pajaro_avifauna}
                alt=""
                className="lg:w-[75rem] md:w-[60rem] sm:w-[50rem] w-[30rem] h-fit-content bottom-32 left-0 absolute "
              />
            </div>
          </div>
         )}
      
    </div>
  );
};

export default BirdLifeScreen;
